import React from 'react';
import PropTypes from 'prop-types';
import * as style from './ArticleCallOutIconList.module.scss';
import ArticleCallOutIconListItem from '../ArticleCallOutIconListItem';

/**
 * Call out Icon Bullet point list, which consist of and icon in black circle, heading and text.
 */
const ArticleCallOutIconList = (props) => {
  const { listItems } = props;

  return (
    <div className={style.callOutList}>
      {listItems?.map((listItem, index) => (
        <ArticleCallOutIconListItem
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          icon={listItem?.iconBulletPointListIcon}
          title={listItem?.iconBulletPointListHeading}
          paragraphs={listItem?.iconBulletPointListTextMultiParagraphSection}
        />
      ))}
    </div>
  );
};

ArticleCallOutIconList.propTypes = {
  /** A list of items */
  listItems: PropTypes.arrayOf(
    PropTypes.shape({
      iconBulletPointListHeading: PropTypes.string,
      iconBulletPointListIcon: PropTypes.string,
      iconBulletPointListTextMultiParagraphSection: PropTypes.arrayOf(
        PropTypes.shape({
          iconBulletPointListTextParagraph: PropTypes.string,
        })
      ),
    })
  ).isRequired,
};

export default ArticleCallOutIconList;
